import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../context/ProductBuilder/machine';
import { isCurrentState } from '../../../../helpers/isCurrentState';
import { getShippingOptions } from '../../../../helpers/shipping';
import { throwError } from '../../../../helpers/throwError';
import { ProductBuilderMachineEvent } from '../../../../types';
import { Heading } from '../../../Common/Heading';
import { Selector, SelectorItem } from '../../../Common/Selector';
import { SectionContent } from '../SectionContent';
import { ShippingMethod } from './ShippingMethod';

type OnClick = (
  shipping: string,
  dynamicPrice: string,
  send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (shipping, dynamicPrice, send) => () => {
  send({
    type: 'UPDATE_CUSTOM',
    custom: {
      shipping,
      dynamicPrice,
    },
  });
};

export const Shipping = () => {
  const [state, send] = useService(productBuilderMachine);
  const {
    custom: { shipping },
  } = state.context;
  const shippingOptions = getShippingOptions(state.context);

  // Price starts at $10 for roller day/nights for the bracket cost
  let airPrice: number =
      window.location.pathname.includes('roller-day-night') === true ? 10 : 0,
    seaPrice: number =
      window.location.pathname.includes('roller-day-night') === true ? 10 : 0;

  shippingOptions.forEach(option => {
    if (option.freight === 'air') airPrice = airPrice + Number(option.price);
    if (option.freight === 'sea') seaPrice = seaPrice + Number(option.price);
  });

  const uniqueShippingOptions = [
    ...new Map(shippingOptions.map(item => [item['freight'], item])).values(),
  ];

  if (isCurrentState('shipping', state) && shippingOptions.length === 0) {
    throwError(state);
  }

  return (
    <SectionContent>
      <Heading>Shipping</Heading>
      <Selector>
        {uniqueShippingOptions.map(option => {
          return (
            <SelectorItem
              onClick={onClick(
                option.freight,
                option.freight === 'air'
                  ? airPrice.toString()
                  : seaPrice.toString(),
                send,
              )}
              isSelected={option.freight === shipping}
              key={option.freight}
              isAltStyle={true}
            >
              <ShippingMethod method={option.freight} />
            </SelectorItem>
          );
        })}
      </Selector>
    </SectionContent>
  );
};
